import React from 'react';
import { Button, CloseButton, DialogActions } from 'pages/TimeClock/modals/base/styled';
import { DialogTitle, DialogDescription, ExportForm, Dialog } from './styled';

const ExportExcelModal = ({ onChange, onCancel, onSubmit, value, onClose, open,  }) => {
  return (
    <Dialog open={open}>
      <CloseButton onClick={onClose} />
      <DialogTitle disableTypography={true}>Excel export</DialogTitle>
      <DialogDescription>
        Select a date period to export. <br />
        Exports a date period including the day selected.
      </DialogDescription>
      {value && <ExportForm value={value} onChange={onChange}  />}
      <DialogActions disableSpacing={false} style={{padding: '0 26px 20px'}}>
        <Button
          variant={'outlined'}
          color={'secondary'}
          fullWidth={true}
          onClick={() => onCancel()}
        >
          Cancel
        </Button>
        <Button variant={'outlined'} fullWidth={true} onClick={() => onSubmit()}>
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportExcelModal;
